import { SCOPE_TYPES } from './types';
import { type ScopeObject, type ScopeType } from './types';

interface Params {
  scopeObject?: ScopeObject;
  scopeType?: ScopeType;
}

export const getSearchNavigationPath = ({
  scopeType,
  scopeObject,
}: Params): string => {
  // Validate params
  if (scopeType && !scopeObject) {
    throw new Error(
      `SearchButton: both scopeType and scopeObject are required to define a path. ScopeType: ${scopeType}`,
    );
  }

  if (scopeType && scopeObject) {
    // It's only topics for now, extend the list below when needed.
    if (scopeType === SCOPE_TYPES.TOPIC) {
      const topicId = scopeObject.id;

      return `${Routes.topic_search_path(topicId)}?topic_id=${topicId}`;
    }
  }

  // Global Search
  return Routes.search_path();
};
